import type { JSX } from 'react';
import { useMemo } from 'react';
import { useClearFocusedAsset } from '@frameio/selection';
import { useManageGenerateAssetsDialog } from './useManageGenerateAssetsDialog';
import { useRemoveBackgroundAction } from './useRemoveBackgroundAction';

export type GenerateAssetsReturn = {
  openGenerateAssetsDialog: (action?: string) => void;
  generateAssetsDialog: JSX.Element | null;
  removeBackground: (assetIds: string[], trim?: boolean) => Promise<boolean>;
};

export const useGenerateAssets = (): GenerateAssetsReturn => {
  const clearFocusedAssetId = useClearFocusedAsset();

  const { createGenerateAssetsDialog, openGenerateAssetsDialog } =
    useManageGenerateAssetsDialog();

  const { removeBackground: removeBackgroundAction } =
    useRemoveBackgroundAction();

  const generateAssetsDialog = useMemo(
    () =>
      createGenerateAssetsDialog({
        onClose: clearFocusedAssetId,
      }),
    [clearFocusedAssetId, createGenerateAssetsDialog]
  );

  return {
    openGenerateAssetsDialog,
    generateAssetsDialog,
    removeBackground: (assetIds, trim) =>
      removeBackgroundAction({ assetIds, trim }),
  };
};
